import { OK } from 'http-status-codes';
import { put, takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { actions, types } from './duck';

export function* getCoupons({ params }) {
  try {
    yield put(actions.getCouponsRequest());
    const response = yield api.getCoupons(params);

    if (response.status === OK) {
      yield put(actions.getCouponsSuccess(response.data.coupons));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCouponsFailure(error.message));
  }
}

export function* getProductsByMids({ mids }) {
  try {
    yield put(actions.getProductsByMidsRequest());
    const response = yield api.getProductsByMids(mids);
    yield put(actions.getProductsByMidsSuccess(response));
  } catch (error) {
    yield put(actions.getProductsByMidsFailure(error.message));
  }
}

export function* getBusinesses() {
  try {
    yield put(actions.getBusinessesRequest());
    const response = yield api.getBusinesses();

    if (response.status === OK) {
      yield put(actions.getBusinessesSuccess(response.data.data));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getBusinessesFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.GET_COUPONS, getCoupons);
  yield takeLatest(types.GET_PRODUCTS_BY_MIDS, getProductsByMids);
  yield takeLatest(types.GET_BUSINESSES, getBusinesses);
}
